






























import Vue from 'vue'
import request from '@/utils/request'
export default Vue.extend({
    data() {
        return {
            name: '',
            phone: '',
            password: '',
            passagain: '',
            classId: '',
            className: ''
        }
    },
    created() {
        const query = this.$route.query
        // @ts-ignore
        this.classId = query.classId
        if (typeof this.classId !== 'undefined') {
            this.getClassData()
        }else {
          this.$Message.warning('班级信息不能为空,请重新扫码')
        }
    },
    methods: {
        getClassData() {
        request.get(`/api/class_info/${this.classId}`)
            .then((data: any) => {
            this.className = data.data.name
            if(this.className == ''){
              this.$Message.warning('班级信息不能为空,请重新扫码')
            }
            })
        },
        submit() {
            if (!this.phone) {return this.$Message.warning('手机号码不能为空!')}
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {return this.$Message.warning('请填写正确的手机号码!')}
            if (!this.password) {return this.$Message.warning('密码不能为空!')}
            if(!this.className){return this.$Message.warning('班级信息不能为空')}
            const params = {
                phone: this.phone,
                password: this.password,
                classId: this.classId
            }
            request.post(`/api/user/bind`, params).then((result) => {
                console.log(result)
                if (result.code === 20000) {
                    this.$Message.success('绑定成功，请等待审核!')
                    sessionStorage.setItem('token', result.data)
                    this.$router.push({ path: '/login' })
                } else {
                  this.$Message.warning(result.msg)

                }
            }).catch((err) => {
                // console.log(err)
                this.$Message.error(err)
              if(err ==='用户已绑定，请勿重复申请'){
                this.$router.push({ path: '/login' })
              }
            })
        },
      goRegister() {
        const getClassId = this.classId
        if(getClassId && getClassId != 'undefined' ){
          this.$router.push({ path: '/register',query:{classId:getClassId} })
        }else{
          this.$router.push({ path: '/register' })
        }
      },
      goLogin() {
        this.$router.push({ path: '/login' })
      }
    }
})
